// extracted by mini-css-extract-plugin
export default {"accountContainer":"Account_accountContainer__s8Dla","accountCard":"Account_accountCard__Lsrh9"};